import React, { Component } from 'react'
import { getImgPath } from "../common/helper";
const date = new Date();
const currentyear = date.getFullYear();
export class footerSTA extends Component {
    render() {
        const staFooterData  =  window.staFooterData;
        const PandCEnquiryno  = staFooterData  ? staFooterData.PandCEnquiryno : "";
        const travelEnquiryno  = staFooterData ? staFooterData.PandCEnquiryno : "";
        const cargoEnquiryno  = staFooterData ? staFooterData.PandCEnquiryno : "";
        const email =           staFooterData ? staFooterData.email : "";
    
        return (
            <div>
                <footer className="site-footer">
                    <div className="upper-footer">
                        <div className="containerfooter">
                            <div className="row">
                                <div className="col col-lg-3 col-md-3 col-sm-6">
                                    <div className="widget link-widget">
                                        <div className="widget-title">
                                            <h3>Bus Booking</h3>
                                        </div>
                                        <ul>
                                            <li><a href="/">Home</a></li>
                                            <li><a href="/about_us">About us</a></li>
                                            <li><a href="/ticket/mybooking">View Booking</a></li>
                                            <li><a href="/ticket/cancel">Cancel</a></li>
                                            <li><a href="/ticket/mybooking/editbooking">Edit Booking</a></li>
                                            <li><a href="/feedback">Feedback</a></li>
                                            <li><a href="/contact_us">Help</a></li>
                                            <li><a href="/route">Routes</a></li>
                                            <li><a href="/photogallery">Bus Gallery</a></li>
                                        </ul>
                                    </div>
                                </div>
                                <div className="col col-lg-3 col-md-3 col-sm-6">
                                    <div className="widget link-widget">
                                        <div className="widget-title">
                                            <h3>Tourism</h3>
                                        </div>
                                        <ul>
                                            <li><a href="#">Tourist Destinations</a></li>
                                            <li><a href="#">Offbeat Detinations</a></li>
                                        </ul>
                                        <div className="widget-title">
                                            <h3>Cargo</h3>
                                        </div>
                                        <ul>
                                            <li><a href="/lrstatus">Track your Cargo</a></li>
                                            <li><a href="/lrstatus">Dispatch Status</a></li>
                                        </ul>
                                    </div>
                                </div>
                                <div className="col col-lg-3 col-md-3 col-sm-6">
                                    <div className="widget contact-widget service-link-widget">
                                        <div className="widget-title">
                                            <h3>Customer Support</h3>
                                        </div>
                                        <ul>
                                            <li>For Payment & Cancellation Enquiry Call us at  <span style={{color:'#fff'}}> {PandCEnquiryno}</span></li>
                                            <li>For Travel Enquiry Call us at <span style={{color:'#fff'}}>{travelEnquiryno}</span></li>
                                            <li>For Cargo Enquiry Call us at <span style={{color:'#fff'}}>{cargoEnquiryno}</span></li>
                                        </ul>
                                    </div>
                                </div>
                                <div className="col col-lg-3 col-md-3 col-sm-6">
                                    <div className="widget contact-widget service-link-widget">
                                        <div className="widget-title">
                                            <h3>Contact</h3>
                                        </div>
                                        <ul>
                                            <li>Email: <a href={'mailto:'+email}>{email}</a></li>
                                        </ul>
                                        <div className="social-icons">
                                            <ul>
                                                <li>Follow:</li>
                                            {
                                              window.staFooterData.facebooklink &&
                                                <li><a href={window.staFooterData.facebooklink} target="_blank"><i className="ti-facebook"></i></a></li>
                                            }      
                                            {
                                             window.staFooterData.instalinnk &&
                                                <li><a href={window.staFooterData.instalinnk} target = "_blank"><i className="ti-instagram"></i></a></li>
                                            }
                                               
                                            {
                                             window.staFooterData.twitterlink && 
                                                <li><a href={window.staFooterData.twitterlink} target="_blank"><i className="ti-twitter"></i></a></li>
                                            }    
                                                   
                                            {
                                             window.staFooterData.linkedinlink &&
                                                <li><a href={window.staFooterData.linkedinlink} target="_blank"><i className="ti-linkedin"></i></a> </li>
                                            }
                                                    
                                          </ul>
                                        </div>
                                        <div className="tag-logo"><img src= {getImgPath("/img/tag.png")} alt /></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="lower-footer">
                        <div className="containerfooter">
                            <div className="row">
                                <div className="separator"></div>
                                <div className="col col-xs-12">
                                    <p className="copyright">
                                    <a href = "#"> © {currentyear} all rights reserved {window.companyName} | Powered by  {"Maventech Labs Private Limited"}</a> 
                                        {/* <a href="http://www.mantistechnologies.com" target="_blank">
                                        <img src= {getImgPath("/img/mantis-logo.png")} alt="Mantis Technologies Private Limited, (Travelyaari™)" title="Mantis Technologies Private Limited, (Travelyaari™)" />
                                        </a> */}
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </footer>
            </div>
        )
    }
}

export default footerSTA
